function getTrainerDesc(trainer, params) {
  if (trainer) {
    let formula, mode

    switch(trainer.component) {
      case 'mental': 
      case 'columns':         
        if (params.formula === '15') {
          formula = 'комбинации'
        } else if (params.formula === '*') {
          formula = 'микс'
        } else {
          formula = params.formula
        }
        return {
          'Формула': formula,
          'Размер': params.rank,
          'Слагаемые': params.terms,
          'Скорость': params.speed
        }

      case 'flash': 
        mode = params.mode === 'train' ? 'трен.' : 'исп.'
        return {
          'Режим': mode,
          'Направление': params.direction ? 'абакус' : 'число',
          'Оси': params.to,
          'Скорость': params.speed,
        }

      case 'multi': 
        mode = params.type === 'multi' ? 'умн.' : 'дел.'
        return {
          'Режим': mode,
          'Количество цифр(1)': params.first.digits,
          'Количество цифр(2)': params.second.digits
        }

      case 'bee': 
        if (params.mode === "where") {
          mode = 'Найди дракошу'
        }
        return {
          'Режим': mode,
          'Размер поля': params.size,
          'Шаги': params.min_steps,
          'Скорость(сек)': params.speed,
        }

      case 'memo':
        return {
          'Карты': params.cards,
          'Подсказка(сек)': params.startTime,
          'Таймер(сек)': params.timer
        }

      case 'shulte':
        return {
          'Режим': params.mode === 'digits' ? 'Цифры' : 'Буквы',
          'Счет': getShulteMode(params.direction),
          'Размер поля': params.size,
          'Поворот': params.rotate
        }

      case 'gorbov':
        return {
          'Размер поля': params.size,
        }

      case 'mnemo':
        return {
          'Размер поля': params.size,
        }
    }
  }  
}

function getShulteMode(direction) {
  if (direction === 'direct') {
    return 'Прямой'
  }
  if (direction === 'reverse') {
    return 'Обратный'
  }
  if (direction === 'random') {
    return 'Случайный'
  }
}

export { getTrainerDesc }